import PageCommon from "./PageCommon.js";
import Pqp from "../3x1010/Pqp.js";
import Globals from "../Globals.js";

export default class PageSingle extends PageCommon {
  constructor() {
    super();
  }

  init($data) {
    super.init($data);
    this.showPreloader(false);
    // console.log("PageSingle");

    let app = document.querySelector(".app");
    let app_dataset = app.dataset.page;
    // page percorso esplora & approfondisci
    if ((app_dataset.includes("page-xcorso-explore")) || (app_dataset.includes("page-xcorso-learn-more"))) {
      let sidebar = "aside";
      let article = "article";
      let accordion_btn = ".js-btn-accordion";
      // aggiungi classe a main-content se sidebar presente
      if ((document.querySelector(sidebar)) && (document.querySelector(article))) {
        document.querySelector(article).classList.add("has-sidebar");
      }
      // preapri primi accoridon in sidebar e article      
      if (document.querySelector(sidebar)) {
        sidebar = document.querySelector(sidebar);
        if (app_dataset.includes("page-xcorso-explore") && (sidebar.querySelector(accordion_btn))) {
          if (!app_dataset.includes("page-xcorso-experiment")) {
            sidebar.querySelector(accordion_btn).classList.add("is-open");
            // TEMP:start
            // da risolvere
            $("base").remove();
            // ^^^ da risolvere
            // TEMP:end
          }                    
        }
      }
      if (document.querySelector(article)) {
        article = document.querySelector(article);
        article.querySelector(accordion_btn)?.classList?.add("is-open");
      }

      if (sidebar && article) {
        // TEMP:start        
        // aggiungi link sidebar nav 
        if (app_dataset.includes("page-xcorso-explore") && !(app_dataset.includes("page-xcorso-experiment"))) {
          let s_accordion = sidebar.querySelector(".js-accordion-wrapper");
          let s_anchors = s_accordion.querySelectorAll("a");
          let sa_size = s_anchors.length;
          for (let i = 0; i < sa_size; i++) {
            s_anchors[i].setAttribute("href", "#target-" + i);
          }
          // aggiungi target article accordions
          let a_accordions = article.querySelectorAll(".js-s-target");
          let aa_size = a_accordions.length;
          let accordion_wrappers = article.querySelectorAll(".js-accordion-wrapper");

          for (let i = 0; i < aa_size; i++) {
            a_accordions[i].setAttribute("name", "target-" + i);
            // apri accordion se link ancora è stato cliccato
            let aa_body = $(".js-accordion-body", accordion_wrappers[i]);
            let btn_accordion = accordion_wrappers[i].querySelector(".js-btn-accordion");
            s_anchors[i].addEventListener("click", (e) => {
              if (!btn_accordion.classList.contains("is-open")) {
                btn_accordion.classList.add("is-open");
                aa_body.slideDown();
              } else {
                return;
              }
            });
          }
        }
        // TEMP:end        
      }

      // init layer immagini in confronto
      let img_comp = ".js-img-comparison";
      if (document.querySelector(img_comp)) {
        this.initImgComp(img_comp);
      }
    }

    // init accordions
    let accordion_wrapper = ".js-accordion-wrapper";
    if (document.querySelector(accordion_wrapper)) {
      let accordion_wrappers = $(accordion_wrapper);
      this.initAccordions(accordion_wrappers);

      // TEMP-LABEL FOCUS ARCHIVI:start
      let accordions = document.querySelectorAll(".js-accordion-wrapper");
      for (let i = 0; i < accordions.length; i++) {
        if (accordions[i].querySelector(".js-btn-accordion").innerText === "Focus Archivi e Fotografi") {
          accordions[i].querySelector(".js-accordion-body").classList.add("has-label-focus-archives");
          let label = document.createElement("h3");
          label.innerText = "Qui troverai maggiori informazioni sugli autori e le autrici, gli Archivi da cui sono tratte le fotografie presentate nel percorso";
          let accinnerheader = accordions[i].querySelector(".accordion-header");
          accordions[i].querySelector(".js-accordion-body").insertBefore(label, accinnerheader);
        }
      }
      // TEMP-LABEL FOCUS ARCHIVI:end
    }

    // page ascolta dettaglio
    // init audio player
    if (app_dataset.includes("page-xcorso-listen")) {
      let audio_player = ".audio-player";
      if (document.querySelector(audio_player)) {
        audio_player = document.querySelector(audio_player);
        this.initAudioPlayer(audio_player);
      }
    }

    $(".js-schedaapprofondiscidownload-submit").on('click', this.onSchedaApprofondisciDownload.bind(this));

    // dispaccio un evento globale
    try {
      this.dispatchInitEvent(TheDisp.EV_PAGETHIS_INITED);
    }
    catch {
      console.error();
    }
  }

  onSchedaApprofondisciDownload() {
    let routePaths = window.location.href.split('/');

    let UrlSlug = routePaths[routePaths.length - 1];
    document.location.href = TheApp.Env.BaseUrlNls + "pages/GetPdf.aspx?slug=" + UrlSlug
  }

  // init accordions
  initAccordions(wrappers) {
    let wrappers_size = wrappers.length;
    for (let i = 0; i < wrappers_size; i++) {
      let accordion_body = $(wrappers[i]).children(".js-accordion-body");
      let btns = $(".js-btn-accordion", wrappers[i]);
      // remove icons if wrapper has no accordion_body
      if (accordion_body.length < 1) {
        btns.addClass("hasnt-child");
      }
      if (btns[0].classList.contains("is-open")) {
        accordion_body.slideDown();
      }
      $(btns[0]).on("click", (e) => {
        if ((accordion_body.is(":hidden")) && (!btns[0].classList.contains("is-open"))) {
          $(btns[0]).addClass("is-open");
          accordion_body.slideDown();
        } else {
          if (btns[0].classList.contains("is-open")) {
            $(btns[0]).removeClass("is-open");
          }
          accordion_body.slideUp();
        }
      });
    }
  }

  // init img comparison
  initImgComp(img_comp) {
    img_comp = $(img_comp);
    let imgs = $("img", img_comp);
    let imgs_layer = $(".js-comparison-layer");
    let il_cont = $(".js-img-left-cont", imgs_layer);
    let ic_cont = $(".js-img-center-cont", imgs_layer);
    let ir_cont = $(".js-img-right-cont", imgs_layer);
    let lightbox_close = ".js-close";

    if (document.querySelector(".img-center")) {
      imgs_layer.addClass("has-3-imgs");
      console.log("sì");
      for (let i = 0; i < imgs.length; i++) {
        $(imgs[i]).on("click", (e) => {
          // set img urls
          let il_url = $("img", ".img-left", img_comp[i]).attr("src");
          let ic_url = $("img", ".img-center", img_comp[i]).attr("src");
          let ir_url = $("img", ".img-right", img_comp[i]).attr("src");
          $("img", il_cont).attr("src", il_url);
          $("img", ic_cont).attr("src", ic_url);
          $("img", ir_cont).attr("src", ir_url);
          // init magnifiers
          $("#left-hide-xs").zoom();
          $("#center-hide-xs").zoom();
          $("#right-hide-xs").zoom();
          $("#left-show-xs").zoom({ on: "grab" });
          $("#center-show-xs").zoom({ on: "grab" });
          $("#right-show-xs").zoom({ on: "grab" });
          // show layer
          //imgs_layer.addClass("open");
          imgs_layer.fadeIn(500);
        });
      }
    } else {
      console.log("falso");
      $(".js-img-center-cont", ".js-comparison-layer").remove();
      for (let i = 0; i < imgs.length; i++) {
        $(imgs[i]).on("click", (e) => {
          // set img urls
          let il_url = $("img", ".img-left", img_comp[i]).attr("src");
          let ir_url = $("img", ".img-right", img_comp[i]).attr("src");
          $("img", il_cont).attr("src", il_url);
          $("img", ir_cont).attr("src", ir_url);
          // init magnifiers
          $("#left-hide-xs").zoom();
          $("#right-hide-xs").zoom();
          $("#left-show-xs").zoom({ on: "grab" });
          $("#right-show-xs").zoom({ on: "grab" });
          // show layer
          //imgs_layer.addClass("open");
          imgs_layer.fadeIn(500);
        });
      }
    }

    $(lightbox_close).on("click", (e) => {
      //current_index = 0;
      //imgs.closest("figure").removeClass("no-pointer-evs");
      imgs_layer.fadeOut();
    });
  }

  // init audio player
  initAudioPlayer(audio_player) {
    let btn_playpause = audio_player.querySelector(".play-pause");
    let audio = document.querySelector("audio");
    let seek_slider = audio_player.querySelector(".seek-slider");
    let current_time = document.querySelector(".current-time");

    audio.addEventListener("loadeddata", (e) => {
      audio.ontimeupdate = (e) => {
        seek_slider.value = audio.currentTime * 100 / audio.duration;
        let mins = "0" + Math.floor(audio.currentTime / 60);
        let secs = "0" + Math.floor(audio.currentTime - mins * 60);
        let dur = mins.substr(-2) + ":" + secs.substr(-2);
        current_time.innerText = dur;
      };

      seek_slider.onchange = (e) => {
        audio.currentTime = audio.duration / 100 * seek_slider.value;
        let mins = "0" + Math.floor(audio.currentTime / 60);
        let secs = "0" + Math.floor(audio.currentTime - mins * 60);
        let dur = mins.substr(-2) + ":" + secs.substr(-2);
        current_time.innerText = dur;
      };
    });

    btn_playpause.addEventListener("click", (e) => {
      if (!audio.paused) {
        audio.pause();
        if (btn_playpause.classList.contains("is-playing")) {
          btn_playpause.classList.remove("is-playing");
        }
      } else {
        audio.play();
        btn_playpause.classList.add("is-playing");
      }
    });
  }
}